@if (workspaceTabs.tabs().length) {
  <div class="workspace-tabs-bar print:hidden" role="toolbar" aria-label="Open pages">
    <div #tabsScroll class="workspace-tabs-scroll">
      @for (group of tabGroups(); track trackByTabGroupKey($index, group)) {
        @if (group.tabs.length === 1 && !group.forceDropdown) {
          @let tab = group.tabs[0];
          <div
            class="workspace-tab"
            [class.workspace-tab-active]="workspaceTabs.activeTabId() === tab.id"
            role="presentation"
          >
            <button
              type="button"
              class="workspace-tab-label"
              (click)="select(tab)"
              matTooltipPosition="below"
              [matTooltip]="tab.title"
              [attr.aria-current]="workspaceTabs.activeTabId() === tab.id ? 'page' : null"
            >
              {{ tab.title }}
            </button>
            <button
              type="button"
              mat-icon-button
              class="workspace-tab-close"
              aria-label="Close tab"
              (click)="close(tab, $event)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        } @else {
          <app-workspace-tab-module-group [group]="group" />
        }
      }
    </div>
  </div>
}
